import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

export const StyledButton = styled(Button)`
    padding: 0 32px 0 16px;
`;

export const GAButtonContainer = styled.div`
    position: relative;
`;

export const StyledIcon = styled(SWReactIcons)`
    position: absolute;
    top: 10px;
    right: 10px;
`;
